import { EMPTY } from './const';

const INDEX_CLASSES = new Map([
  [0, 'first'],
  [1, 'second'],
  [2, 'third'],
  [3, 'fourth'],
  [4, 'fifth'],
  [5, 'sixth'],
]);

export const getIndexClass = (index: number): string =>
  INDEX_CLASSES.get(index) ?? EMPTY;
